<template>
  <div v-show="showUrgentAlertModal">
    <div class="urgent_modal">
      <div class="overlay"></div>
      <div class="urgent_modal_position">
        <div class="urgent-alert-card">
          <div class="urgent-alert-card-inner">
            <Flicking
              v-if="modal_list.length > 1"
              style="height: 100%"
              :options="{ circular: true }"
              :plugins="plugins"
            >
              <div class="urgent_modal_layout" v-for="(modal, i) in modal_list" :key="i">
                <div class="contents">
                  <!-- 타이틀 1 -->
                  <div class="urgent_title" v-html="modal.title"></div>
                  <!-- 타이틀 1 -->

                  <!-- 서브 타이틀 1 (urgent) -->
                  <div
                    v-if="modal.content.sub_title !== '' && modal.type === 'urgent'"
                    class="urgent_title_second"
                  >
                    {{ modal.content.sub_title }}
                  </div>
                  <!-- 서브 타이틀 1 (urgent) -->

                  <!-- 서브 타이틀 1 (non urgent) -->
                  <div v-else-if="modal.content.sub_title !== ''" class="urgent_title_second2">
                    {{ modal.content.sub_title }}
                  </div>
                  <!-- 서브 타이틀 1 (non urgent) -->

                  <!-- 콘텐츠 1 (urgent) -->
                  <div
                    class="urgent_modal_content first-second mt-5 mb-4"
                    v-if="modal.type === 'urgent'"
                  >
                    <div
                      class="first mt-3"
                      v-if="modal.content.content_first"
                      v-html="modal.content.content_first"
                    ></div>
                  </div>
                  <!-- 콘텐츠 1 (urgent) -->

                  <!-- 콘텐츠 1 (non urgent) -->
                  <div v-else class="urgent_modal_content2">
                    <div
                      v-html="modal.content.content_first"
                      v-if="modal.content.content_first"
                    ></div>
                    <a
                      class="urgent_modal_btn"
                      v-if="modal.content.content_first_button"
                      :href="modal.content.content_first_url"
                      :target="modal.content.content_first_external"
                      >{{ modal.content.content_first_button }}</a
                    >
                  </div>
                  <!-- 콘텐츠 1 (non urgent) -->
                </div>

                <div class="contents">
                  <!-- 타이틀 2 -->
                  <div
                    class="urgent_title"
                    v-html="modal.content.second_title"
                    v-if="modal.content.second_title"
                  ></div>
                  <!-- 타이틀 2 -->

                  <!-- 콘텐츠 2 (non urgent) -->
                  <div
                    class="urgent_modal_content2"
                    v-if="modal.type === 'notice' && modal.content.content_second"
                  >
                    <div
                      v-html="modal.content.content_second"
                      v-if="modal.content.content_second"
                    ></div>

                    <a
                      class="urgent_modal_btn"
                      v-if="modal.content.content_second_button"
                      :href="modal.content.content_second_url"
                      :target="modal.content.content_second_external"
                      >{{ modal.content.content_second_button }}</a
                    >
                  </div>
                  <!-- 콘텐츠 2 (non urgent) -->
                </div>

                <!-- 콘텐츠 3 (urgent) -->
                <div
                  class="urgent_modal_content third"
                  v-if="modal.type === 'urgent' && modal.content.content_third"
                  v-html="modal.content.content_third"
                ></div>
                <!-- 콘텐츠 3 (urgent) -->
              </div>
              <template #viewport>
                <span class="flicking-arrow-prev is-circle"></span>
                <span class="flicking-arrow-next is-circle"></span>
                <div class="flicking-pagination"></div>
              </template>
            </Flicking>
            <div v-else>
              <div class="urgent_modal_layout" v-for="(modal, i) in modal_list" :key="i">
                <div class="contents">
                  <!-- 타이틀 1 -->
                  <div class="urgent_title" v-html="modal.title"></div>
                  <!-- 타이틀 1 -->

                  <!-- 서브 타이틀 1 (urgent) -->
                  <div
                    v-if="modal.content.sub_title !== '' && modal.type === 'urgent'"
                    class="urgent_title_second"
                  >
                    {{ modal.content.sub_title }}
                  </div>
                  <!-- 서브 타이틀 1 (urgent) -->

                  <!-- 서브 타이틀 1 (non urgent) -->
                  <div v-else-if="modal.content.sub_title !== ''" class="urgent_title_second2">
                    {{ modal.content.sub_title }}
                  </div>
                  <!-- 서브 타이틀 1 (non urgent) -->

                  <!-- 콘텐츠 1 (urgent) -->
                  <div
                    class="urgent_modal_content first-second mt-5 mb-4"
                    v-if="modal.type === 'urgent'"
                  >
                    <div
                      class="first mt-3"
                      v-if="modal.content.content_first"
                      v-html="modal.content.content_first"
                    ></div>
                  </div>
                  <!-- 콘텐츠 1 (urgent) -->

                  <!-- 콘텐츠 1 (non urgent) -->
                  <div v-else class="urgent_modal_content2">
                    <div
                      v-html="modal.content.content_first"
                      v-if="modal.content.content_first"
                    ></div>
                    <a
                      class="urgent_modal_btn"
                      v-if="modal.content.content_first_button"
                      :href="modal.content.content_first_url"
                      :target="modal.content.content_first_external"
                      >{{ modal.content.content_first_button }}</a
                    >
                  </div>
                  <!-- 콘텐츠 1 (non urgent) -->
                </div>

                <div class="contents">
                  <!-- 타이틀 2 -->
                  <div
                    class="urgent_title"
                    v-html="modal.content.second_title"
                    v-if="modal.content.second_title"
                  ></div>
                  <!-- 타이틀 2 -->

                  <!-- 콘텐츠 2 (non urgent) -->
                  <div
                    class="urgent_modal_content2"
                    v-if="modal.type === 'notice' && modal.content.content_second"
                  >
                    <div
                      v-html="modal.content.content_second"
                      v-if="modal.content.content_second"
                    ></div>

                    <a
                      class="urgent_modal_btn"
                      v-if="modal.content.content_second_button"
                      :href="modal.content.content_second_url"
                      :target="modal.content.content_second_external"
                      >{{ modal.content.content_second_button }}</a
                    >
                  </div>
                  <!-- 콘텐츠 2 (non urgent) -->
                </div>

                <!-- 콘텐츠 3 (urgent) -->
                <div
                  class="urgent_modal_content third"
                  v-if="modal.type === 'urgent' && modal.content.content_third"
                  v-html="modal.content.content_third"
                ></div>
                <!-- 콘텐츠 3 (urgent) -->
              </div>
            </div>
            <div class="urgent_modal_footer">
              <span class="no_more_modal" @click="noMoreUrgentAlert">
                {{ $t('modal.urgent.seven') }}
              </span>
              <span
                class="no_more_modal just_close"
                @click="$store.commit('toggleUrgentAlertModal', { state: false })"
              >
                {{ $t('modal.close') }}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { AutoPlay, Pagination, Arrow } from '@egjs/flicking-plugins';
export default {
  name: 'UrgentAlert',
  props: {},
  mounted() {
    this.getUrgentAlertContent();
  },
  created() {},
  computed: {
    ...mapState({
      showUrgentAlertModal: (state) => state.showUrgentAlertModal,
    }),
  },
  data() {
    return {
      plugins: [
        new AutoPlay({ duration: 5000, direction: 'NEXT', stopOnHover: false }),
        new Pagination({ type: 'bullet' }),
        new Arrow(),
      ],
      modal_list: [],
      origin_modal_list: [],
    };
  },
  methods: {
    isNoMoreModal() {
      this.modal_list = this.modal_list.filter((data) => {
        const cookie = this.$cookies.get('noMoreUrgentAlert_' + data.id);

        if (cookie) {
          const daysBerweenDates = Math.round(
            Math.abs(new Date(cookie) - new Date(this.toStringByFormatting(new Date()))) /
              (1000 * 60 * 60 * 24)
          );

          if (daysBerweenDates > 7) {
            return true;
          }
          return false;
        }
        return true;
      });

      if (this.modal_list.length === 0) {
        this.$store.commit('toggleUrgentAlertModal', { state: false });
      }
    },
    getUrgentAlertContent() {
      const ax = this.$axios;
      ax.get(`${process.env.VUE_APP_TEST_SERVER}/popup/notice`).then((response) => {
        const resData = response.data.data;
        if (!(resData.length === 0)) {
          this.$store.commit('toggleUrgentAlertModal', { state: true });

          resData.forEach((data) => {
            this.modal_list.push({
              ...data,
            });
            this.origin_modal_list.push({
              ...data,
            });
          });
          this.isNoMoreModal();
        }
      });
    },
    noMoreUrgentAlert() {
      this.$store.commit('toggleUrgentAlertModal', { state: false });
      const data = this.origin_modal_list;

      data.forEach((el) => {
        const cookie = 'noMoreUrgentAlert_' + el.id;

        this.$cookies.set(cookie, this.toStringByFormatting(new Date()));
      });
    },
    toStringByFormatting(source, delimiter = '-') {
      const year = source.getFullYear();
      const month = String(source.getMonth() + 1).padStart(2, '0');
      const day = String(source.getDate()).padStart(2, '0');
      return [year, month, day].join(delimiter);
    },
  },
};
</script>

<style lang="scss">
.photo-event {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 4px;

  img {
    aspect-ratio: 1 / 1;
  }
}
</style>

<style lang="scss">
@keyframes open_urgent_modal {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.urgent_modal,
.overlay {
  animation: open_urgent_modal 0.2s;
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 9;
}
.overlay {
  background-color: rgba(0, 0, 0, 0.5);
}
.urgent_modal_position {
  display: grid;
  place-items: center;
  height: 75%;
}
.urgent_title {
  font-style: normal;
  font-weight: bold;
  font-size: 33px;
  line-height: 44px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #333333;
}
.urgent_title_second {
  background: #e31511;
  position: fixed;
  left: 50%;
  top: 135px;
  font-style: normal;
  font-weight: bold;
  font-size: 24px;
  text-align: center;
  letter-spacing: -0.01em;
  color: #ffffff;
  transform: translate(-50%, 0%);
  padding: 2px 10px;
}
.urgent_title_second2 {
  font-size: 25px;
  font-weight: 700;
  margin-bottom: 20px;
}
.urgent-alert-card-inner {
  width: 100%;
  height: 100%;
  border-radius: 5px;
  background: #fff;
  margin: 0;
}
.urgent-alert-card {
  display: inline-block;
  position: relative;
  max-width: 600px;
  max-height: 95%;
  width: 600px;
  margin: auto;
  background-color: #1c4a9f;
  z-index: 11;
  opacity: 1;
  overflow: unset;
  aspect-ratio: 1/1;
  border: 20px solid #1c4a9f;
  border-bottom: 35px solid #1c4a9f;
  border-radius: 5px;
}
.urgent_modal_layout {
  padding: 20px 30px;
  height: 100%;
  width: 100%;
  display: grid;
  place-content: center;

  .contents {
    padding: 20px 0;
  }
}
.urgent_modal_content {
  padding: 20px 0;
  white-space: pre-line;
}
.urgent_modal_content2 {
  margin-top: 20px;
  word-break: keep-all;
}
.urgent_modal_content.first-second {
  margin: 0 50px;
  font-style: normal;
  font-weight: normal;
  text-align: center;
  word-break: keep-all;
  color: #333333;
  border-top: 2px solid #e31511;
  border-bottom: 2px solid #e31511;
}
.urgent_modal_content .first {
  font-weight: bold;
  font-size: 24px;
}
.urgent_modal_content .second {
  font-size: 16px;
  letter-spacing: -0.04em;
}
.urgent_modal_content.third {
  font-size: 20px;
  letter-spacing: -0.04em;
}
.urgent_modal_content.fourth {
  padding-bottom: 0;
}
.urgent_modal_btn,
.urgent_modal_btn:active,
.urgent_modal_btn:hover,
.urgent_modal_btn:focus {
  color: #fff;
  font-weight: 700;
  font-size: 17px;
  padding: 10px 50px;
  border-radius: 50px;
  background: #1f3159;
  display: inline-block;
  margin-top: 20px;
}
.urgent_modal_footer {
  text-align: left;
  color: #fff;
  font-weight: 500;
  padding: 7px 14px;
  position: absolute;
  bottom: -38px;
  width: 100%;
}
.important {
  color: red;
}
.important.big {
  font-size: 20px;
}
.no_more_modal {
  cursor: pointer;
}
.no_more_modal.just_close {
  position: absolute;
  right: 14px;
}
@media screen and (max-width: 1119px) {
  .urgent-alert-card-inner {
    height: unset;
  }
  .urgent-alert-card {
    max-width: 80%;
    max-height: 85%;
    width: 312px;
    border: 10px solid #1c4a9f;
    border-bottom: 25px solid #1c4a9f;
  }
  .urgent_modal_layout {
    position: unset;
    top: 0;
    transform: translate(0, 0);
    height: 310px;
    overflow: auto;
    padding: 10px;
    place-content: unset;

    .contents {
      padding: 10px 0;
    }
  }
  .urgent_title {
    font-size: 18px;
    line-height: unset;
    white-space: pre-line;
    margin-bottom: 5px;
  }
  .urgent_title_second {
    font-size: 14px;
    top: 37.5%;
  }
  .urgent_title_second2 {
    font-size: 15px;
    margin-bottom: 10px;
  }
  .urgent_modal_content {
    font-size: 12px;
  }
  .urgent_modal_content2 {
    margin: 0;
    font-size: 12px;
    padding: 0 10px 10px 10px;
  }
  .urgent_modal_content.first-second {
    padding: 0 0 10px !important;
    margin: 0 10px !important;
  }
  .urgent_modal_content .first {
    font-size: 14px;
  }
  .urgent_modal_content .second {
    font-size: 12px;
  }
  .urgent_modal_content.third {
    padding: 10px 0 0 !important;
    font-size: 12px;
  }
  .urgent_modal_btn,
  .urgent_modal_btn:active,
  .urgent_modal_btn:hover,
  .urgent_modal_btn:focus {
    font-size: 12px;
    padding: 7px 30px;
  }
  .urgent_modal_footer {
    font-size: 12px;
    padding: 0 14px;
    bottom: -22px;
  }
}
</style>
